import { authHeader, handleResponse } from '../helpers';
import Vue from 'vue'

export const userService = {
    login,
    logout,
    register,
    getLoggedIn,
    getMenu,
    getAll,
    getById,
    update,
    delete: _delete,
    getSezone
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username:username, password:password })
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                let currentTime = new Date().getTime(); 
                localStorage.setItem('userAuthenticated', currentTime.toString());
            }

            return user;
        });
}

export function logout() {
    // return authorization header with jwt token
    localStorage.removeItem('user');
    localStorage.removeItem('userAuthenticated');
    localStorage.removeItem('userDetails');
    //
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/register`, requestOptions).then(handleResponse);
}

function getLoggedIn() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/uporabnik`, requestOptions)
    .then(handleResponse)
    .then(user => {
           
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('userDetails', JSON.stringify(user));
           return user;
        });
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users`, requestOptions).then(handleResponse);
}

function getSezone() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/sezone`, requestOptions).then(handleResponse);
}


function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/${user.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function getMenu(){


var menuData=[
   {
      "text":"Pridelovalci",
      "icon":"tractor",
      "name":"pridelava",
      "path":"/pridelava/:urlSezona?",
      "component":"Pridelava",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
      ,
      "submenu":[
   //},
   {
      "text":"Gerki",
      "icon":"layer-group",
      "name":"vsiGerki",
      "path":"/vsiGerki/:urlSezona?",
      "component":"VsiGerki",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Kulture",
      "icon":"seedling",
      "name":"kulture",
      "path":"/kulture/:urlSezona?/",
      "component":"Kulture",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Živali",
      "icon":"horse-head",
      "name":"zivali",
      "path":"/zivali/:urlSezona?/",
      "component":"Zivali",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Proizvodi",
      "icon":"cheese",
      "name":"proizvodi",
      "path":"/proizodi/:urlSezona?/",
      "component":"Proizvodi",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Kontrole",
      "icon":"search-location",
      "name":"kontrole",
      "path":"/kontrole/:urlSezona?/",
      "component":"Kontrole",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Odločbe",
      "icon":"file-contract",
      "name":"odlocbe",
      "path":"/odlocbe/:urlSezona?/",
      "component":"Odlocbe",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Certifikati",
      "icon":"certificate",
      "name":"certifikati",
      "path":"/certifikati/:urlSezona?/",
      "component":"Certifikati",
      "pravice":"PRIDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   }]
   //,
 },

    {
      "text":"Predelovalci",
      "icon":"industry",
      "name":"predelava",
      "path":"/predelava/:urlSezona?/",
      "component":"Predelava",
      "pravice":"PREDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ],
   //},
    "submenu":[
   {
      "text":"Dislocirane enote",
      "icon":"building",
      "name":"dislociraneEnote",
      "path":"/dislociraneEnote/:urlSezona?/",
      "component":"DislociraneEnote",
      "pravice":"PREDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Dejavnosti",
      "icon":"cogs",
      "name":"dejavnosti",
      "path":"/dejavnosti/:urlSezona?/",
      "component":"Dejavnosti",
      "pravice":"PREDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
    {
      "text":"Kontrole",
      "icon":"search-location",
      "name":"kontrolePredelava",
      "path":"/kontrolePredelava/:urlSezona?/",
      "component":"KontrolePredelava",
      "pravice":"PREDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   },
   {
      "text":"Certifikati",
      "icon":"certificate",
      "name":"certifikatiPredelava",
      "path":"/certifikatiPredelava/:urlSezona?/",
      "component":"CertifikatiPredelava",
      "pravice":"PREDELAVA_BERI",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   }]
 },
   //,
   {
      "text":"Urejanje šifrantov",
      "icon":"list",
      "name":"sifrant",
      "path":"/sifrant/:urlSezona?/",
      "component":"Sifrant",
      "pravice":"SIFRANT_PISI",
      "skupine":[
         "MKGP"
      ]
   },
   {
      "text":"Pravice nad pridelovalci",
      "icon":"user-shield",
      "name":"pravicePridelava",
      "path":"/pravicePridelava/:urlSezona?/",
      "component":"PravicePridelava",
      "pravice":"PRAVICE_PISI",
      "skupine":[
         "MKGP"
      ]
   },
   {
      "text":"Pravice nad predelovalci",
      "icon":"user-cog",
      "name":"pravicePredelava",
      "path":"/pravicePredelava/:urlSezona?/",
      "component":"PravicePredelava",
      "pravice":"PRAVICE_PISI",
      "skupine":[
         "MKGP"
      ]
   },
   {
      "text":"Odjava",
      "icon":"sign-out-alt",
      "name":"logout",
      "path":"/logout",
      "component":"LogoutPage",
      "pravice":"JAVNO",
      "skupine":[
         "MKGP","UVHVVR","KO"
      ]
   }
]

 var promise = new Promise(function(resolve, reject) {
    /* missing implementation */
    resolve(menuData);
  });

  return promise;
}